import { onBeforeUnmount, onMounted, ref } from 'vue'

export function useChartResize () {
  const chartRef = ref(null)

  const handleResize = () => {
    if (chartRef.value) {
      chartRef.value.resize()
    }
  }

  onMounted(() => {
    window.addEventListener('resize', handleResize)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize)
    if (chartRef.value) {
      chartRef.value.dispose()
    }
  })

  return {
    chartRef,
    handleResize
  }
}
